// extracted by mini-css-extract-plugin
export var headerContainer = "Header-module--headerContainer--FtUPP";
export var linksContainer = "Header-module--linksContainer--1SHXJ";
export var navLink = "Header-module--navLink--A9cGk";
export var searchIcon = "Header-module--searchIcon--uRyzA";
export var btn = "Header-module--btn--4fEta";
export var mobileIcon = "Header-module--mobileIcon--pJcMx";